module.exports = __webpack_public_path__ + "zvetseni-prsou_10_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-prsou_10_before_tn.jpg
// module id = 1762
// module chunks = 0